// File: /src/components/KanbanCard.js

import React from 'react';
import { useDraggable } from '@dnd-kit/core';

const KanbanCard = ({ project }) => {
	const { attributes, listeners, setNodeRef, transform, isDragging } =
		useDraggable({ 
			id: project.id,
			data: {
				type: 'project',
				project
			}
		});

	const style = transform ? {
		transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
	} : undefined;

	// Formatar data
	const formatDate = (dateString) => {
		if (!dateString) return 'Sem data';
		const date = new Date(dateString);
		return date.toLocaleDateString('pt-BR', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric',
		});
	};

	// Formatar valor
	const formatValue = (value) => {
		if (!value) return 'R$ 0,00';
		return new Intl.NumberFormat('pt-BR', {
			style: 'currency',
			currency: 'BRL',
		}).format(value);
	};

	return (
		<div
			ref={setNodeRef}
			style={style}
			{...attributes}
			{...listeners}
			className={`kanban-card ${isDragging ? 'kanban-card-dragging' : ''}`}
		>
			<div className="kanban-card-header">
				<h4 className="kanban-card-title">{project.name}</h4>
				<span className="kanban-card-drag-handle">⋮⋮</span>
			</div>

			{project.description && (
				<p className="kanban-card-description">{project.description}</p>
			)}

			<div className="kanban-card-details">
				<div className="kanban-card-client">
					<span className="kanban-card-label">Cliente:</span>
					<span className="kanban-card-value">
						{project.client?.name || 'Não informado'}
					</span>
				</div>

				<div className="kanban-card-value-display">
					<span className="kanban-card-label">Valor:</span>
					<span className="kanban-card-value kanban-card-price">
						{formatValue(project.value)}
					</span>
				</div>

				<div className="kanban-card-dates">
					<div className="kanban-card-date">
						<span className="kanban-card-label">Início:</span>
						<span className="kanban-card-value">
							{formatDate(project.start_date)}
						</span>
					</div>
					<div className="kanban-card-date">
						<span className="kanban-card-label">Fim:</span>
						<span className="kanban-card-value">
							{formatDate(project.end_date)}
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default KanbanCard;
